import { render, staticRenderFns } from "./recovery_code.vue?vue&type=template&id=713a9df6"
import script from "./recovery_code.vue?vue&type=script&lang=js"
export * from "./recovery_code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports